"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerContent = exports.LabelIcon = exports.TabsSpaceFiller = exports.ContainerTabs = exports.ContainerTabsPanel = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.ContainerTabsPanel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"])));
exports.ContainerTabs = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), function (props) { return (props.borderBottom ? '' : ''); });
exports.TabsSpaceFiller = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n  border-bottom: ", "px\n    solid;\n  border-bottom-color: ", ";\n"], ["\n  flex-grow: 1;\n  border-bottom: ", "px\n    solid;\n  border-bottom-color: ", ";\n"])), function (props) {
    return props.borderBottom ? props.borderBottom : 2;
}, function (props) {
    return props.lineColor ? props.lineColor : 'rgba(142,142,142,0.36)';
});
exports.LabelIcon = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  border-style: solid;\n  height: 100%;\n  padding:", " ;\n  cursor: pointer;\n  border-style: solid;\n  border: none;\n  ", ";\n  ", "\n  & > div, span{\n  ", ";\n  ", ";\n  }\n}"], ["\n  display: flex;\n  align-items: center;\n  border-style: solid;\n  height: 100%;\n  padding:", " ;\n  cursor: pointer;\n  border-style: solid;\n  border: none;\n  ", ";\n  ", "\n  & > div, span{\n  ", ";\n  ", ";\n  }\n}"])), function (props) {
    return props.padding
        ? props.padding
        : props.size === 'small'
            ? '6px 15px'
            : '8px 20px';
}, function (props) {
    return props.active && props.activeBackgroundColor
        ? "background-color:".concat(props.activeBackgroundColor, "!important;")
        : '';
}, function (props) {
    return props.active
        ? "\n      ".concat(props.backgroundColor
            ? "background-color: ".concat(props.backgroundColor, ";")
            : '', "\n  border-bottom: ").concat(props.activeBorderColor
            ? "2px solid ".concat(props.activeBorderColor, " !important")
            : '2px solid #3d3e3e !important', ";\n      top: 2px;\n      position: relative;\n      padding-bottom: 10px;\n  ")
        : "\n    border-width: 0;\n    background-color: transparent;\n    ";
}, function (props) {
    return props.active && props.activeTextColor
        ? "color:".concat(props.activeTextColor, "!important;")
        : '';
}, function (props) {
    return !props.active && props.textColor
        ? "color:".concat(props.textColor, "!important;")
        : '';
});
exports.ContainerContent = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-width: 0 1px 1px 1px;\n  border-style: solid;\n  ", ";\n  border-color: ", ";\n  padding: ", ";\n  border-radius: 0 1px 2px 2px;\n"], ["\n  border-width: 0 1px 1px 1px;\n  border-style: solid;\n  ", ";\n  border-color: ", ";\n  padding: ", ";\n  border-radius: 0 1px 2px 2px;\n"])), function (props) {
    return props.backgroundColor ? "background-color: ".concat(props.backgroundColor, ";") : '';
}, function (props) {
    return props.borderColor ? props.borderColor : '#dbdcdd';
}, function (props) {
    return props.padding ? props.padding : '25px';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
